import { render, staticRenderFns } from "./WrapperImage.vue?vue&type=template&id=6d7a0dd3&scoped=true"
import script from "./WrapperImage.vue?vue&type=script&lang=js"
export * from "./WrapperImage.vue?vue&type=script&lang=js"
import style0 from "./WrapperImage.vue?vue&type=style&index=0&id=6d7a0dd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a0dd3",
  null
  
)

export default component.exports